import apis from "./axios.config";
const api = apis.DepApi;

export default {
  CtrMenu() {
    return api.post("dep2640/MenuList");
  },

  CtrNews() {
    return api.post("dep2640/NewsList");
  },
  GetNewsDetail(t) {
    return api.post("dep2640/NewsDetail", t);
  },
  CtrCarePaper() {
    return api.post("dep2640/CarePaperList");
  },
  CtrLink() {
    return api.post("dep2640/LinkList");
  },
};
